// extracted by mini-css-extract-plugin
export default {"container":"SearchList__container___QPlLe"};